$(document).ready(function () {

    $('.hero').not('.slick-initialized').slick(
        {
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            cssEase: 'linear',
            speed: 900,
            autoplaySpeed: 4000,
            pauseOnHover: false,
            pauseOnFocus: false,
            adaptiveHeight: false,
        });

    $('.case-study-gallery-main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        autoplay: true,
        asNavFor: '.case-study-gallery-nav'
    });

    $('.case-study-gallery-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        asNavFor: '.case-study-gallery-main',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true
    });

    $('.carousel-main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        autoplay: true,
        asNavFor: '.carousel-nav',
        adaptiveHeight: true
    });

    $('.carousel-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        asNavFor: '.carousel-main',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true
    });

    $('.menu-btn').click(function () {
        $('.main-nav ul.nav').addClass('active');
    });

    $('.close-menu').click(function () {
        $('.main-nav ul.nav').removeClass('active');
    });

    $('.menu-item-has-children').click(function () {
        $(this).children('.dropdown-wrap').toggleClass('active');
    });

    if ($('.gallery-wrap').length) {
        $('.gallery-wrap').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    }
    $('.sliding-col-content').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        dots: false,
        arrows: true,
        autoplaySpeed: 5000,
        speed: 2000,
        prevArrow: "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
    });

    $('.faqs-ul li').on("click", function (event) {
        $(this).toggleClass("active-faq");
        $(this).find('.faq-answers').toggle();
    });

    if ($('body').hasClass('home')) {
        var div = document.createElement('div');
        div.className = 'container full-width bg-off-white';
        var copy = $('.flexible-content-wrap').children().eq(1).clone(true, true);
        $(div).append(copy);
        $('.flexible-content-wrap').children().eq(1).replaceWith(div);
    }

    $('.full-width-bg-content.testimonials .inner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        dots: false,
        arrows: false,
        autoplaySpeed: 5000,
        speed: 2000
    });

    $('.container.bg-off-white').each(function (k, v) {
        var next = $(this).next();
        if (!$(next).hasClass('container') || !$(next).hasClass('bg-off-white')) {
            $(this).addClass('bottom_padded');
        }
    });

    $('.full-width-bg-content').each(function (k, v) {
        $(this).parent().prev().addClass('bottom_padded');
    });


});
